<template>
  <v-container>
    <v-row align="center">
      <v-col cols="2">
        <BaseSelect
          label="Marca"
          v-model="selectedMarca"
          :items="marcas"
          hide-details
          @change="triggerFetchModeloArmas($event)"
        />
      </v-col>
      <v-col cols="2">
        <BaseSelect
          label="Modelo"
          v-model="selectedModelo"
          :items="catalogoModeloArma"
          hide-details
          @change="triggerConsultaMovimientos($event)"
        />
      </v-col>
      <v-spacer></v-spacer>
      <v-col align="right">
        <TextButton @click="openRegistroMovimientoDialog"> REGISTRAR MOVIMIENTO </TextButton>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card" color="primary" :loading="loading">
          <v-card-title>
            <div class="text-h6">Movimientos de arma</div>
            <v-spacer></v-spacer>
            <v-alert color="secondary" class="white--text" v-if="!loading"> Disponibles: {{ getDisponibles }} </v-alert>
          </v-card-title>
          <v-card-text>
            <v-data-table :headers="headers" class="transparent" :items="filteredMovimientos">
              <template v-slot:[`item.fk_idcatTipoMovimiento`]="{ item }">
                <div v-if="item.fk_idcatTipoMovimiento == 1" class="text-body-2">Entrada</div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import BaseSelect from '../../../base/BaseSelect.vue'
import TextButton from '../../../base/TextButton.vue'
import { DIALOG_TYPES } from '@/plugins/dialog-types.js'

export default {
  components: {
    BaseSelect,
    TextButton,
  },
  async mounted() {
    await this.fetchMovimientoArma()
  },
  data() {
    return {
      loading: false,
      selectedMarca: null,
      selectedModelo: null,
      DIALOG_TYPES,

      headers: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Tipo de movimiento', value: 'fk_idcatTipoMovimiento' },
        { text: 'Modelo', value: 'CatModelo.modelo' },
        { text: 'Cantidad', value: 'cantidad' },
      ],
    }
  },
  computed: {
    ...mapGetters('marcaArma', {
      marcas: 'getMarcaArma',
    }),

    ...mapGetters('modeloArma', {
      modeloArma: 'getModelosArmas',
      catalogoModeloArma: 'getCatalogoModeloArma',
    }),

    ...mapGetters('movimientoArma', {
      movimientoArma: 'getMovimientoArma',
      movimientoArmaDisponibles: 'getMovimientoArmaDisponibles',
    }),

    filteredMovimientos: function () {
      return this.movimientoArma.filter((movimiento) => {
        return movimiento.fk_idCatModelo == this.selectedModelo
      })
    },

    getDisponibles: function () {
      if (this.loading || !this.selectedModelo) {
        return 0
      } else return this.movimientoArmaDisponibles[0].disponibles
    },
  },
  methods: {
    ...mapActions('modeloArma', ['fetchModeloArmas']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapActions('movimientoArma', ['fetchMovimientoArmaDisponibles', 'fetchMovimientoArma']),

    async triggerConsultaMovimientos() {
      this.loading = true
      await this.fetchMovimientoArmaDisponibles(this.selectedModelo)
      this.loading = false
    },

    async triggerFetchModeloArmas(event) {
      this.loading = true
      this.selectedModelo = null
      await this.fetchModeloArmas(event)
      this.loading = false
    },
    openRegistroMovimientoDialog() {
      this.SET_DIALOG(DIALOG_TYPES.REGISTRO_MOVIMIENTO_ARMA)
    },
  },
}
</script>
